import { TeamBadge } from '@components/transfers/TeamBadge';

type TeamCellProps = {
  shortName: string;
  height: number;
};

export const TeamCell = ({ shortName, height }: TeamCellProps) => (
  <div className="flex items-center gap-2 pl-2 pr-3" style={{ height }}>
    <TeamBadge shortName={shortName} size="sm" />
    <span className="text-sm font-semibold text-neutral-800">{shortName}</span>
  </div>
);
